<fieldset>
    <form-field-select name="import_match"
                       [label]="'Match' | translate"
                       [(ngModel)]="selected.match"
                       [options]="options"
                       nameAttr="name"
                       [helpTxt]="'Can be - title, url, full_url, metadata, content'"
                       returnValue="value"
    ></form-field-select>


    <form-field-select name="import_match_rule"
                       [label]="'Match rule' | translate"
                       [(ngModel)]="selected.match_rule"
                       [options]="options"
                       nameAttr="name"
                       [helpTxt]="'Can be - contains, starts_with, ends_with, is_exactly, regexp'"
                       returnValue="value"
    ></form-field-select>

    <form-field-select name="import_text"
                       [label]="'Text' | translate"
                       [(ngModel)]="selected.text"
                       [options]="options"
                       nameAttr="name"
                       returnValue="value"
    ></form-field-select>

    <form-field-select name="import_exclude"
                       [label]="'Exclude' | translate"
                       [(ngModel)]="selected.exclude"
                       [options]="options"
                       nameAttr="name"
                       [helpTxt]="'Can be - false (included), true (excluded)'"
                       returnValue="value"
    ></form-field-select>
</fieldset>
